import { useAuth } from 'app/context/auth-context';
import EmployerAdminPage from 'app/modules/employer-admin/EmployerAdminPage';
import NoJobfairSelected from 'app/modules/job-seeker/components/NoJobfairSelected';
import JobFairJoinComponent from 'app/modules/job-seeker/JobfairJoin';
import { adminUrl, employerAdminUrl, jobSeekerUrl, recruiterUrl, Roles } from 'app/types';
import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';

import { FallbackView } from '../../_metronic/partials';

const RedirectToReturnUrl = ({ defaultPath }: { defaultPath: string }) => {
  const { state } = useLocation<{ returnUrl?: string }>();
  if (state?.returnUrl) {
    return <Redirect to={state.returnUrl} />;
  }
  return <Redirect to={defaultPath} />;
};

export function PrivateRoutes () {
  const JSPage = lazy(() => import('../modules/job-seeker/JSPage'));
  const AdminPage = lazy(() => import('../modules/admin/AdminPage'));
  const RecruiterPage = lazy(() => import('../modules/recruiter/RecruiterPage'));

  const { user } = useAuth();

  const jobSeekerRoutes = (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path={jobSeekerUrl} component={JSPage} />
        <Route path='/join/:alias' component={JobFairJoinComponent} />
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath={jobSeekerUrl} />} />

        <Route path='/' component={NoJobfairSelected} />
      </Switch>
    </Suspense>
  );

  const adminRoutes = (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path={adminUrl} component={AdminPage} />
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath={adminUrl} />} />
        <Redirect to={adminUrl} />
      </Switch>
    </Suspense>
  );

  const recruiterRoutes = (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path={recruiterUrl} component={RecruiterPage} />
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath={recruiterUrl} />} />
        <Redirect to={recruiterUrl} />
      </Switch>
    </Suspense>
  );

  const employerAdminRoutes = (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path={employerAdminUrl} component={EmployerAdminPage} />
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath={employerAdminUrl} />} />
        <Redirect to={employerAdminUrl} />
      </Switch>
    </Suspense>
  );

  const employerAdminAndRecruiterRoutes = (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path={employerAdminUrl} component={EmployerAdminPage} />
        <Route path={recruiterUrl} component={RecruiterPage} />
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath={employerAdminUrl} />} />
        <Redirect to={employerAdminUrl} />
      </Switch>
    </Suspense>
  );

  if (user?.roles?.includes(Roles.Applicant)) { return jobSeekerRoutes; }
  if (user?.roles?.includes(Roles.Admin)) { return adminRoutes; }
  if (user?.roles?.includes(Roles.EmployerAdmin) && user?.roles?.includes(Roles.Recruiter)) { return employerAdminAndRecruiterRoutes; }
  if (user?.roles?.includes(Roles.EmployerAdmin)) { return employerAdminRoutes; }
  if (user?.roles?.includes(Roles.Recruiter)) { return recruiterRoutes; }

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>
        <Route path='/auth' render={() => <RedirectToReturnUrl defaultPath='/dashboard' />} />
        <Redirect exact from='/' to='/dashboard' />
        <Redirect to='error/404' />
      </Switch>
    </Suspense>
  );
}
